import { configureStore } from '@reduxjs/toolkit'
import ApiReducer from './Reducers/ApiReducer'
import UserReducer from './Reducers/UserReducer'
import TableReducer from './Reducers/TableReducer'
import RolesAndPermissionReducer from './Reducers/RoleAndPermissionReducer/RoleAndPermissionReducer'
import FloorReducer from './Reducers/FloorReducer'
import GropPaginationReducer from './Reducers/GroupPagination'
import ServicePaginationReducer from './Reducers/ServicePagination'
import BillingReducer from './Reducers/BiliingReducer'
import CreateSurvey from './Reducers/CreateSurvey'
import ExpenseReducer from './Reducers/ExpenseReducer'
import ClosingReducer from './Reducers/ClosingReducer'
import BuyStockReducer from './Reducers/BuyStockReducer'
import AutoBillReducer from './Reducers/AutoBillReducer'

export const store = configureStore({
  reducer: {
    ApiReducer: ApiReducer,
    UserReducer: UserReducer,
    TableReducer: TableReducer,
    RolesAndPermissionReducer: RolesAndPermissionReducer,
    FloorReducer: FloorReducer,
    GropPaginationReducer: GropPaginationReducer,
    ServicePaginationReducer: ServicePaginationReducer,
    BillingReducer: BillingReducer,
    CreateSurvey: CreateSurvey,
    ClosingReducer: ClosingReducer,
    ExpenseReducer: ExpenseReducer,
    BuyStockReducer: BuyStockReducer,
    AutoBillReducer: AutoBillReducer

  },
})